<template>
  <div id="commonChartLine" ref="chartContainer">
    <highcharts :options="chartData" ref="chart"></highcharts>
  </div>
</template>
<script>
export default {
  name: "commonChartLine",
  props: ["data", "chartHeight", "id", "export"], //optional prop export for exporting the chart
  data() {
    return {
      chartData: {},
      resizeObservers: [],
    };
  },
  watch: {
    data: {
      deep: true,
      handler: function () {
        this.initiate();
        this.resizeChart();
      },
    },
  },
  mounted() {
    this.initiate();
    this.$nextTick(() => {
      this.setupResizeObservers([
        { ref: "chartContainer", method: this.resizeChart },
      ]);
    });
  },

  beforeDestroy() {
    this.disconnectResizeObservers();
  },

  methods: {
    setupResizeObservers(charts) {
      charts.forEach(({ ref, method }) => {
        const observer = new ResizeObserver(() => method());
        observer.observe(this.$refs[ref]);
        this.resizeObservers.push(observer);
      });
    },
    disconnectResizeObservers() {
      // this.resizeObservers.forEach((observer) => observer.disconnect());
      // this.resizeObservers = [];
      if (Array.isArray(this.resizeObservers)) {
        this.resizeObservers.forEach((observer) => observer.disconnect());
        this.resizeObservers = [];
      }
    },
    // resizeChart() {
    //   if (this.$refs.chart.chart) {
    //     this.$refs.chart.chart.reflow();
    //   }
    // },
    resizeChart() {
      if (
        this.$refs.chart &&
        this.$refs.chart.chart &&
        typeof this.$refs.chart.chart.reflow === "function"
      ) {
        this.$refs.chart.chart.reflow();
      }
    },

    initiate() {
      let self = this;
      let legendYaxis = 0;
      if (!self.data.subtitle) {
        self.data.subtitle = {
          text: "",
        };
      } else {
        legendYaxis = -35;
      }
      if (!self.data.marginTop) self.data.marginTop = 40;
      self.chartData = {
        chart: {
          type: "line",
          height: this.chartHeight ? this.chartHieight : "350",
          marginTop: self.data.marginTop,
          marginBottom: 60,
          reflow: true,
        },
        title: {
          text: "",
        },
        exporting: {
          enabled: self.export ? true : false,
        },
        subtitle: self.data.subtitle,
        xAxis: {
          categories: self.data.xAxis,
          title: {
            text: null,
          },
          crosshair: {
            width: 70,
          },
          labels: {
            y: 32,
            style: {
              color: "#a1a1a1",
              fontFamily: "Heebo",
              fontWeight: 400,
              fontSize: "14px",
              // letterSpacing: '1px',
            },
          },
        },
        tooltip: {
          shared: true,
          borderWidth: 1,
          borderColor: "rgba(212, 212, 212, 1)",
          shadow: {
            color: "rgba(0, 0, 0, 0.25)",
            opacity: 0.1,
            width: 10,
          },
          borderRadius: 15,
          backgroundColor: "#ffffff",
        },
        plotOptions: {
          line: {
            dataLabels: {
              enabled: true,
              allowOverlap: true,
              style: { fontWeight: 0 },
              formatter: function () {
                return this.point.y;
              },
            },
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: self.data.yAxisTitle ? self.data.yAxisTitle : "",
            // style: { fontSize: '14px', fontFamily: "Poppins", fontWeight: "600", color: "#01695C", letterSpacing: '1px' },
          },
          labels: {
            x: -23,
            style: {
              color: "#a1a1a1",
              fontFamily: "Heebo",
              fontWeight: 400,
              fontSize: "14px",
              // letterSpacing: '1px',
            },
          },
          lineWidth: 1,
          gridLineDashStyle: "longdash",
        },
        // tooltip: {
        //   shared: true,
        // },
        legend: {
          enabled: true,
          alignColumns: true,
          align: "right",
          y: legendYaxis,
          x: 0,
          squareSymbol: true,
          verticalAlign: "top",
          itemDistance: 35,
          margin: 0,
          padding: 0,
          symbolHeight: 14,
          symbolWidth: 14,
          symbolRadius: 4,
          itemStyle: {
            color: "#a1a1a1",
            fontSize: "14px",
            fontWeight: 600,
            fontFamily: "Poppins",
            textTransform: "capitalize",
            letterSpacing: "1px",
          },
          itemHoverStyle: {
            color: "#065559", // Hover color
          },
        },
        credits: {
          enabled: false,
        },
        series: this.data.seriesData,
      };
    },
  },
};
</script>

<style scoped></style>
